function DespesasCartoes() {
  const inputValor = $('#valor');

  inputValor.valid();

  inputValor.on('input', checkTransactionValue);
}

function checkTransactionValue(event) {
  const input = $(event.target);
  const inputAmount = input.val();
  const transactionAmount = $(event.target).attr('transaction-amount');

  input.valid();

  if (typeof transactionAmount !== 'undefined') {
    const divCardAlert = $('#card-alert');

    // Retirando . caso o valor for maior que 1000
    const validateAmount = inputAmount.replace('.', '');

    if (parseFloat(validateAmount.replace(',', '.')) <= parseFloat(transactionAmount.replace(',', '.'))) {
      divCardAlert.removeClass('card-alert');
    }

    if (parseFloat(validateAmount.replace(',', '.')) > parseFloat(transactionAmount.replace(',', '.'))) {
      divCardAlert.addClass('card-alert');
    }
  }
}

module.exports = {
  init: DespesasCartoes,
  url: /^\/despesas\/\d+/
}

